import { FC } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import CoverageDenied, { DenialTypes } from "containers/CoverageDenied/CoverageDenied";
import { useScreenTestId } from "modules/hooks/useScreenTestId";
import { RootState } from "store";

import { withTransaction } from "@elastic/apm-rum-react";
import { defaultTo } from "lodash-es";

interface IProps {
  isReinstatementJourney?: boolean;
  type?: DenialTypes;
}

const CoverageDeniedRoute: FC<IProps> = ({ isReinstatementJourney, type }) => {
  const params = useParams() as { type?: DenialTypes };
  const latestCase = useSelector((state: RootState) => state.cases.latestCase);
  const screenTestId = useScreenTestId();

  let denialType = defaultTo(params?.type, type) || "default";

  if (isReinstatementJourney && denialType === "rejected") {
    denialType = "rejected_reinstatement";
  }

  return (
    <div data-testid={screenTestId}>
      <CoverageDenied type={denialType} latestCase={latestCase} />
    </div>
  );
};

export default withTransaction("CoverageDeniedRoute", "component")(CoverageDeniedRoute);
